import type { I18nService } from '@core/i18n-legacy';
import { SupportedNumberFormat, valueFormatter, ValueFormatterOptions } from '@core/utils-legacy';

const floorToOrderOfMagnitude = (val: number) => Math.pow(10, Math.floor(Math.log10(val)));

export const numberAxisLabelFormatter = (options: ValueFormatterOptions, i18n: I18nService) => {
  let lastOom: number;
  let standardFormatOnly = false;

  return (value: number) => {
    let result: string;
    const oom = floorToOrderOfMagnitude(value);

    if (standardFormatOnly || (lastOom !== 0 && oom === 1000 && lastOom === 100)) {
      standardFormatOnly = true;
      result = valueFormatter(value, options, i18n, {
        number: { format: SupportedNumberFormat.IntlStandard },
      });
    } else {
      result = valueFormatter(value, options, i18n, {
        number: { format: SupportedNumberFormat.IntlCompact },
      });
    }

    lastOom = oom;
    return result;
  };
};
